import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class sensaiProgressBar_template extends vnTemplate {
  protected initPartial() {}

  protected buildViewModel(): any {
    let self = this;
    return {
      score: ko.observable(),
    };
  }

  protected getTemplateHtml(): string {
    return /*html*/ `

        <div class="form-header">
              <h3 class="form-title">Content Optimization Score</h3>
        </div>
        <div class="w-progress-bar">
          <div class="progress-bar">
              <div class="progress-segment red"></div>
              <div class="progress-segment orange"></div>
              <div class="progress-segment yellow"></div>
              <div class="progress-segment light-green"></div>
              <div class="progress-segment green"></div>
          </div>
          <div class="slider" id="slider"></div>
          <div class="notch top"></div>
          <div class="notch bottom"></div>
        </div>
        <div class="progress-icons">
          <div class="icon red-icon"></div>
          <div class="icon orange-icon"></div>
          <div class="icon silver-icon"></div>
          <div class="icon gold-icon"></div>
        </div>
        `;
  }

  protected getTemplateName(): string {
    return "sensaiProgressBar_template";
  }

  protected getMainElementClasses(): Array<string> {
    return ["w-content"];
  }

  protected getMainElementType(): string {
    return "div";
  }

  private calculatePercentage(score : number){
    let positionPercent = 0;
    let badge = "red";
    if (score < 20.00) {
      // First 33% of the width for 0-19 (Red)
      positionPercent = (score / 19) * 33;
      badge = "red";
      if(positionPercent >=33 && positionPercent < 34){
        positionPercent = 31;
      }
    } else if (score >= 20.00 && score < 35.00) {
      // Next 33% of the width for 20-34 (Orange)
      positionPercent = 33 + ((score - 20) / 14) * 33;

      if(positionPercent >=66 && positionPercent < 67){
        positionPercent = 65;
      }
      badge = "orange";
    } else if (score >= 35.00 && score < 50.00) {
      // Next 33% of the width for 35-49 (Light Green)
      positionPercent = 66 + ((score - 35) / 14) * 33;
      badge = "silver";
    } else if (score >= 50.00) {
      // 95% for 50 (Dark Green)
      positionPercent = 97;
      badge = "gold";
    }

      return {positionPercent, badge};
  }

  public updateSliderPosition(threshold) {

    let score = parseFloat(this.getTemplateViewModel().score());
    const sliders = document.getElementsByClassName("slider");
    const notches = document.querySelectorAll(".notch");

    let { positionPercent, badge } = this.calculatePercentage(score);
    let notchPercent = this.calculatePercentage(threshold).positionPercent;

    Array.from(sliders).forEach((sliderElement) => {
      const slider = sliderElement as HTMLElement;
      slider.style.left = `calc(${positionPercent}% - 1% )`;

      slider.style.display = "block";
    });

    Array.from(notches).forEach((notchElement) => {
      const notch = notchElement as HTMLElement;
      notch.style.left = `calc(${notchPercent}% - 1% )`;
    });

    const allBadgeiconInstances = document.getElementsByClassName(badge + "-icon");
    const activeElements = document.querySelectorAll('.progress-icons .is-active');
    
    //remove any active elements before updating the badge
    if(activeElements){

      Array.from(activeElements).forEach((element) => {
        element.classList.remove("is-active");
      });
    }

    Array.from(allBadgeiconInstances).forEach((iconElement) => {
      const icon = iconElement as HTMLElement;
      icon.classList.add("is-active");
    });

    const feedback = document.querySelectorAll('.feedback');
    if(feedback){
      Array.from(feedback).forEach((element) => {
        element.classList.add("feedback-"+badge);
      });
    }
    
  }
  public setScore(score, threshold: number) {
    this.getTemplateViewModel().score(null);
    this.getTemplateViewModel().score(parseFloat(score));
    this.updateSliderPosition(threshold);
  }

  public getScore() {
    return this.getTemplateViewModel().score();
  }
}



// WEBPACK FOOTER //
// ./js/components/templates/sensaiProgressBar_template.ts